import styled from 'styled-components';
import { SxProps, Typography, Theme } from '@mui/material';
import { Flex } from '../Flex';
import { TextFieldProps } from '../TextField';
import { COMPONENT_SIZE_MAP } from '../../types/types';
import { radius, space } from '../../style/utils';

type StyledTextFieldProps = {
  $size?: TextFieldProps['size'];
};

const Wrapper = styled(Flex)<StyledTextFieldProps>`
  border: 1px solid ${({ theme }) => theme.palette.border.control};
  padding: ${space('xs', 'sm')};
  border-radius: ${radius('lg')};
  align-items: center;
  min-height: ${({ $size }) => COMPONENT_SIZE_MAP[$size || 'medium']}px;
`;

type Props = {
  className?: string;
  value?: string;
  size?: TextFieldProps['size'];
  sx?: SxProps<Theme>;
};

export const TextFieldReadOnly = ({ className, sx, value, size }: Props) => (
  <Wrapper className={className} sx={sx} $size={size}>
    <Typography>{value}</Typography>
  </Wrapper>
);

export default TextFieldReadOnly;
